module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1020-70be61c13f66797f258f20dbf1bb75a9.png";